
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TryNewAtlasBanner extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: 'A new Automated PO experience is available.' })
  readonly message!: string;
}
